import { Cell, CellType } from '../_base/table-cell.entity';

export class CheckCell extends Cell {
    constructor(public readonly show: boolean) {
        super(CellType.CHECK);
    }
}
